import React from 'react';
import {
  FaCheck,
  FaTimes,
  FaExclamationTriangle,
  FaInfo,
  FaClock
} from 'react-icons/fa';

const badgeStyle = (bg, color) => ({
  padding: '0.25rem 0.5rem',
  backgroundColor: bg,
  color: color,
  borderRadius: '0.25rem',
  fontSize: '0.8rem',
  fontWeight: '500',
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem'
});

const STATUS_CONFIG = {
  'nowa': { bg: 'var(--info-light)', color: 'var(--info)', text: 'Nowa', icon: FaInfo },
  'oczekujaca': { bg: 'var(--warning-light)', color: 'var(--warning)', text: 'Oczekująca', icon: FaClock },
  'weryfikacja': { bg: 'var(--info-light)', color: 'var(--info)', text: 'Weryfikacja', icon: FaExclamationTriangle },
  'zatwierdzona': { bg: 'var(--success-light)', color: 'var(--success)', text: 'Zatwierdzona', icon: FaCheck },
  'dodana': { bg: 'var(--success-light)', color: 'var(--success)', text: 'Dodana (PZ)', icon: FaCheck },
  'zrealizowana': { bg: 'var(--success-light)', color: 'var(--success)', text: 'Zrealizowana', icon: FaCheck },
  'odrzucona': { bg: 'var(--danger-light)', color: 'var(--danger)', text: 'Odrzucona', icon: FaTimes }
};

const MAPPING_STATUS_CONFIG = {
  'zmapowany': { bg: 'var(--success-light)', color: 'var(--success)', text: 'Zmapowany', icon: FaCheck },
  'niezmapowany': { bg: 'var(--danger-light)', color: 'var(--danger)', text: 'Niezmapowany', icon: FaTimes },
  'wymaga_weryfikacji': { bg: 'var(--warning-light)', color: 'var(--warning)', text: 'Wymaga weryfikacji', icon: FaExclamationTriangle }
};

export const getStatusBadge = (status) => {
  const config = STATUS_CONFIG[status] || { bg: 'var(--border)', color: 'var(--text)', text: status, icon: FaInfo };
  const IconComponent = config.icon;
  return (
    <span style={badgeStyle(config.bg, config.color)}>
      <IconComponent style={{ fontSize: '0.75rem' }} />
      {config.text}
    </span>
  );
};

export const getMappingStatusBadge = (status) => {
  const config = MAPPING_STATUS_CONFIG[status] || { bg: 'var(--border)', color: 'var(--text)', text: status, icon: FaInfo };
  const IconComponent = config.icon;
  return (
    <span style={badgeStyle(config.bg, config.color)}>
      <IconComponent style={{ fontSize: '0.75rem' }} />
      {config.text}
    </span>
  );
};
